import type { JSX } from "react";

export const ROUTE_NAMES: Record<string, string> = {
  HOME: "home",
  CLIENTS: "clients",
  PRE_REGISTER: "pre-register",
  USERS: "users",
  ONBOARDING: "onboarding",
  ONBOARDING_ERROR: "onboarding/error",
  RFP: "rfp",
  RFPS: "rfps",
  DOCUMENT_CHECKLIST: "document-checklist",
  CLIENT_SELECTION: "client-selection",
  CARRIERS_ORDER: "carriers-order",
  PROFILE: "profile",
  BROKERS: "brokers",
  CONSULTING: "consulting",
  DASHBOARD: "dashboard",
  LOGIN: "login",
  ANALYSTS: "analysts",
  TEAMS: "teams",
  RESET_PASSWORD: "reset-password",
  RFP_CARRIER_TRACKER: "carrier-tracker",
  RFP_WORKBENCH_LAUNCHPAD: "launchpad",
  RFP_WORKBENCH_DETAILS: "details",
  RFP_WORKBENCH_BUILD_2: "build-2",
  RFP_WORKBENCH_BUILD_2_FORMS: "forms",
  RFP_WORKBENCH_CENSUS: "census",
  RFP_WORKBENCH_TRACK: "track",
  RFP_WORKBENCH_PRESENT: "present",
  RFP_WORKBENCH_PRESENT_RESPONSES: "responses",
  RFP_WORKBENCH_PRESENT_COMPS: "comps",
  RFP_WORKBENCH_PRESENT_FINANCIAL: "financial",
  RFP_WORKBENCH_PRESENT_QUOTES: "quotes",
  RFP_WORKBENCH_DELIVERABLES: "deliverables",
  RFP_WORKBENCH_FINAL: "final",
  BROKER_PARTNER_SUBMITTED_RFPS: "submitted-rfps",
  BROKER_PARTNER_DRAFT_RFPS: "draft-rfps",
  BROKER_PARTNER_CONNECTED_CARRIERS: "connected-carriers",
  BROKER_PARTNER_CONFIGURATION: "configuration",
  MP_CONFIGS: "mp-configs",
  CARRIERS_REP_DIRECTORY: "carriers-rep-directory",
  BBE: "broker-bonus-estimator",
  BBE_BROKER: "bbe-broker",
  BBE_FORECAST: "forecast",
  BBE_MONTHLY_PROGRESS: "monthly-progress",
  BBE_SCENARIO_MODELING: "scenario-modeling",
  BBE_BROKER_SETTINGS: "broker-settings",
  BBE_CARRIER_BONUS_DETAILS: "carrier-bonus-details",
};

// Pages an unauthenticated user may visit without being redirected to login.
export const OPEN_PAGES: string[] = [
  ROUTE_NAMES["ONBOARDING"],
  ROUTE_NAMES["ONBOARDING_ERROR"],
  ROUTE_NAMES["RESET_PASSWORD"],
];

// Location-state key carrying the URL to return to after login.
export const PREV_URL = "prevUrl";

export type UserType =
  | "admin"
  | "broker"
  | "agent"
  | "analyst"
  | "consultant"
  | "broker_analyst";

export type RouteConfig = {
  path: string;
  element: JSX.Element;
  children?: RouteConfig[];
  roles?: UserType[];
};
